






















































































































































































































import {Component, Vue} from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import {mapGetters} from "vuex";
import VueGoogleAutocomplete from "@/components/VueGoogleAutocomplete.vue";
import {ESettoreDescription, ESettori, EUserType} from "@/types";
import {removeUndefined} from "@/utils";

@Component({
    components: {VueGoogleAutocomplete,},
    name: "WorkerForm",
    computed: {
        ...mapGetters({user: 'user', profile: 'profile'})
    }
})

export default class WorkerForm extends Vue {
    private user?: any;
    private profile?: any;
    private worker: any = {};
    private save_state: number = 0;
    private defaultValues: any = {
        nome: "",
        cognome: "",
        indirizzo: "",
        num_telefono: "",
        email: "",
        periodo_da: "",
        periodo_a: "",
        giorni_per_settimana: null,
        settori: [ESettori.Allevamento, ESettori.Florovivaismo, ESettori.Ortofrutta, ESettori.ViteOlivo],
        raggio_di_spostamento: null,
        patente: undefined,
        patente_agricola: undefined,
        veicolo: undefined,
        qualifiche: '',
        tipologia: EUserType.Worker
    };


    // Alternative
    private settori = [{text: ESettoreDescription[ESettori.Ortofrutta], value: ESettori.Ortofrutta},
        {text: ESettoreDescription[ESettori.Florovivaismo], value: ESettori.Florovivaismo},
        {text: ESettoreDescription[ESettori.ViteOlivo], value: ESettori.ViteOlivo},
        {text: ESettoreDescription[ESettori.Allevamento], value: ESettori.Allevamento}];
    private raggi = [{text: 'Scegli...', value: null},
        {text: "15 km", value: 15},
        {text: "30 km", value: 30},
        {text: "50 km", value: 50},
        {text: "100 km", value: 100}]

    private created() {
        this.worker = {
            ...this.defaultValues,
            ...{
                num_telefono: this.user.phoneNumber || '',
                email: this.user.email || ''
            },
            ...this.profile
        }
    }

    //@ts-ignore
    private getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
    }

    get saveState(){
        return this.save_state;
    }

    set saveState(val: number) {
        if (val == 1) {
            this.save_state = 1;
        }
        if (val == 2) {
            setTimeout(() => {
                this.save_state = 2;
                setTimeout(() => {
                    this.save_state = 0
                }, 2000);
            }, 2000)
        }
        if (val == 3) {
            setTimeout(() => {
                this.save_state = 3;
                setTimeout(() => {
                    this.save_state = 0
                }, 2000);
            }, 2000)
        }
    }

    private saveWorker() {
        this.saveState = 1;
        firebase.firestore().collection('users').doc(this.user.id)
            .set(removeUndefined(this.worker)).then(() => {
            this.$store.dispatch('setProfileRefs');
            this.saveState = 2;
            this.$emit('saved')
        }).catch(()=>{
            this.saveState = 3;
        })
    }

    private manageSave(invalid:boolean, errors:[]){
        if(invalid){
            //FIXME mi sembra strano che il pacchetto di validazione non permetta un metodo semplice per far riprendere il focus...
            (document.querySelector('input.is-invalid') as HTMLElement).focus()
        } else {
            this.saveWorker();
        }
    }

    private setAddressData(data: any) {
        this.worker = {...this.worker, ...data}
    }
}
